// src/routes/lazyPublicPages.js
import { lazy } from "react";

export const LoginUI = lazy(() => import("../LoginUI"));
export const LoginUIMobile = lazy(() => import("../LoginUIMobile"));
export const EmailSendUI = lazy(() => import("../EmailSendUI"));
export const MyProfile = lazy(() => import("../MyProfile"));
export const VacanciesMobUI = lazy(() => import("../MobUI/VacanciesMobUI"));
export const VacanciesUI = lazy(() => import("../VacanciesUI"));
export const RecruitmentVacancyPageMobUI = lazy(() => import("../MobUI/RecruitmentVacancyPageMobUI"));
export const RecruitmentVacancyPageUI = lazy(() => import("../RecruitmentVacancyPageUI"));
export const RecruiterRegistrationPageMobUI = lazy(() => import("../MobUI/RecruiterRegistrationPageMobUI"));
export const RecruiterRegistrationPageUI = lazy(() => import("../RecruiterRegistrationPageUI"));
export const TermsandConditions = lazy(() => import("../PC/TermsandConditions"));
export const PrivacyPolicy = lazy(() => import("../PC/PrivacyPolicy"));
export const UserPasswordResetUI = lazy(() => import("../UserPasswordResetUI"));
